import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { TabRouterLessNavigationItem } from '@app/navigation/navigation.model';
import { ProfileSkillSignalsPageViewModel } from '@app/profile/components/profile-skill-signals-page-v2/profile-skill-signals.model';
import { ProfileSkillSignalsPageFacade } from '@app/profile/components/profile-skill-signals-page-v2/profile-skill-signals-page.facade';
import { ReactiveListVM } from '@dg/shared-rsm';
import { ExperienceItem } from '@app/profile/components/profile-overview/experiences-v2/profile-experience.facade';
import { AchievementItem } from '@app/profile/components/profile-overview/achievements-v2/achievements.facade';
import { LearningItem } from '@app/profile/components/profile-overview/learning-v2/profile-learning.facade';

@Component({
  selector: 'dgx-profile-skill-signal-page-v2',
  templateUrl: './profile-skill-signal-page.component.html',
  styleUrls: ['./profile-skill-signal-page.component.scss'],
})
export class ProfileSkillSignalPageV2 implements OnDestroy {
  public readonly CLASS_NAME = 'ProfileSkillSignalPageV2';

  public i18n = this.translateService.instant([
    'Core_All',
    'Core_Ratings',
    'Core_ExperiencesDisplayName',
    'Core_Achievements',
    'Core_Learnings',
  ]);

  public vm$: Observable<ProfileSkillSignalsPageViewModel>;
  public readonly experiencesList$: Observable<ReactiveListVM<ExperienceItem>>;
  public readonly achievementsList$: Observable<
    ReactiveListVM<AchievementItem>
  >;
  public readonly learningsList$: Observable<ReactiveListVM<LearningItem>>;

  public tagId: number;
  public tabList: TabRouterLessNavigationItem[] = [
    {
      name: this.i18n.Core_All,
      nameId: 'All',
    },
    {
      name: this.i18n.Core_Ratings,
      nameId: 'Ratings',
    },
    {
      name: this.i18n.Core_ExperiencesDisplayName,
      nameId: 'Experiences',
    },
    {
      name: this.i18n.Core_Achievements,
      nameId: 'Achievements',
    },
    {
      name: this.i18n.Core_Learnings,
      nameId: 'Learnings',
    },
  ];

  constructor(
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private facade: ProfileSkillSignalsPageFacade
  ) {
    this.experiencesList$ = this.facade.experiencesSearch$;
    this.achievementsList$ = this.facade.achievementsSearch$;
    this.learningsList$ = this.facade.learningsSearch$;
    this.tagId = Number(this.route.snapshot.queryParams.tagId);
    this.switchTab();
    facade.tagId = this.tagId;
    this.vm$ = facade.vm$;
    if (!this.facade.enabled) {
      this.facade.enabled = true;
    }
  }

  public switchTab(signalType: string = 'All'): void {
    this.facade.setSignalType(signalType);
  }

  public ngOnDestroy() {
    this.facade.enabled = false;
  }
}
